<template>
    <b-container>
        <h1>Re-order items</h1>
        <b-alert variant="danger" :show="alertError">
            {{ stripeErrorMsg }}
        </b-alert>
        <b-card title="Order Items">
            <b-form>
                <b-form-group label="Table Number (required)">
                    <b-overlay :show="init_loading" opacity="0.6">

                        <b-form-select id="table_no" v-model="table_no">
                            <b-form-select-option :value="table_no" v-for="(table_no, index) in numberOfTables"
                                                  :key="index">
                                {{ table_no }}
                            </b-form-select-option>
                        </b-form-select>
                        <b-form-invalid-feedback v-if="errors.table_no">{{ errors.table_no[0] }}
                        </b-form-invalid-feedback>
                    </b-overlay>
                </b-form-group>

                <b-form-group label="Your name (required)">
                    <b-form-input type="text" v-model="customer_name"></b-form-input>
                    <b-form-invalid-feedback v-if="errors.customer_name">{{ errors.customer_name[0] }}
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Email address (required)">
                    <b-form-input type="email" v-model="email_address"></b-form-input>
                    <b-form-invalid-feedback v-if="errors.email_address">{{ errors.email_address[0] }}
                    </b-form-invalid-feedback>
                </b-form-group>


                <table class="table">
                    <thead>
                    <tr>
                        <th>Item</th>
                        <th>Price</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in this.orderDetails.order_items" :key="index">
                        <td>{{ item.item_name }}
                            <ul class="list p-0 list-unstyled">
                                <li v-for="(modifier, index) in item.selectedModifiers" :key="index">
                                    <span class="text-muted small">{{ modifier.name }} ({{formatMoney(modifier.price)}})</span>
                                </li>
                            </ul>
                        </td>
                        <td>{{ formatMoney(item.total_price) }}</td>
                    </tr>
                    </tbody>
                </table>

                <table class="table">
                    <tr>
                        <th>Sub-total</th>
                        <td>£{{ formatMoney(this.sub_total)}}</td>
                    </tr>
                    <tr>
                        <th>Service charge</th>
                        <td>£{{ formatMoney(this.service_charge)}}</td>
                    </tr>
                    <tr>
                        <th>Total</th>
                        <td>£{{ formatMoney(this.total)}}</td>
                    </tr>
                </table>


                <div id="paypal-button-container"></div>

                <hr>
                <span class="d-block text-center text-muted">OR</span>
                <hr>

                <b-card class="mb-4" title="Choose card">
                    <b-form-group label="Select card to use">
                        <b-overlay :show="cards_loading" opacity="0.6">
                            <b-alert variant="warning"
                                     :show="paymentMethodsLoadStatus == 2 && paymentMethods.length == 0">
                                No payment method on file, please add a payment method.
                            </b-alert>
                            <b-list-group>
                                <b-list-group-item v-for="(method, key) in paymentMethods" :key="'method-'+key"
                                                   v-on:click="paymentMethodSelected = method.id"
                                                   v-bind:class="{'active': paymentMethodSelected == method.id}">
                                    {{ method.brand.charAt(0).toUpperCase() }}{{ method.brand.slice(1) }} | {{
                                    method.last_four }}
                                </b-list-group-item>
                            </b-list-group>
                        </b-overlay>
                    </b-form-group>
                </b-card>


                <b-form-group>
                    <b-button size="lg" variant="primary" block disabled v-if="loading">
                        <b-spinner small type="grow"></b-spinner>
                        Loading...
                    </b-button>
                    <b-button @click="payByCard" size="lg" v-else variant="primary" block>Order & Pay</b-button>
                </b-form-group>

            </b-form>
        </b-card>
    </b-container>
</template>

<script>
    import Vue from "vue";
    import {stripeTestKey} from "../../paymentConfig.json";

    export default {
        name: "ViewPreviousOrder",

        data() {
            return {
                loading: false,
                cards_loading: false,
                orderDetails: '',
                order_no: this.$route.params.order_no,
                stripeAPIToken: stripeTestKey,
                alertError: false,
                stripeErrorMsg: false,
                init_loading: false,
                table_no: '',
                customer_name: '',
                email_address: '',
                errors: '',
                numberOfTables: 0,

                paypalCredentials: {
                    sandbox: 'AWNsde4K1V_utHBgIRqh0mSLnnEp0DH6vGjqJOv60H5qE8DVNVtaXOXAU5NbEpVgh2GRnGLpmnKw2zcP',
                    production: 'AWNsde4K1V_utHBgIRqh0mSLnnEp0DH6vGjqJOv60H5qE8DVNVtaXOXAU5NbEpVgh2GRnGLpmnKw2zcP'
                },
                payPalButtonStyle: {
                    label: 'checkout',
                    size: 'responsive',
                    shape: 'pill',
                    color: 'gold'
                },
                stripe: '',
                elements: '',
                card: '',

                name: '',
                addPaymentStatus: 0,
                addPaymentStatusError: '',
                intentToken: '',
                paymentMethods: [],
                paymentMethodsLoadStatus: 0,
                paymentMethodSelected: {},

                sub_total: '',
                service_charge: '',
                total: '',
            }
        },

        watch: {
            orderDetails: function (orderDetails) {
                this.initPaypal(orderDetails.order_total)
            }
        },

        mounted() {
            this.getSettings();
            this.getProfileData();
            this.getOrderDetails();
            Vue.loadScript("https://js.stripe.com/v3/").then(() => {
                this.configureStripe();
            });
            this.loadPaymentMethods();
        },

        methods: {
            createSubTotal(service_charge){
                new Promise((resolve, reject) => {
                    let sum = 0;
                    this.getProductsInCart.forEach(function (item) {
                        sum += parseFloat(item.total);
                    });
                    resolve(sum);
                }).then( (sum) => {
                    console.log('sum', sum)
                    this.sub_total = sum
                    this.total =  +sum + +service_charge;
                    this.initPaypal(this.total);
                } );
            },
            /*
             *******************************
                STRIPE CARD MANAGEMENT
             *******************************
             */
            loadIntent() {
                axios.get('/user/setup-intent')
                    .then(function (response) {
                        this.intentToken = response.data;
                    }.bind(this));
            },
            configureStripe() {
                this.stripe = Stripe(this.stripeAPIToken);

                this.elements = this.stripe.elements();
                this.card = this.elements.create('card', {
                    hidePostalCode: true,
                    style: {
                        base: {
                            fontWeight: 500,
                            fontFamily: 'Raleway, sans-serif',
                            fontSize: '16px',
                            fontSmoothing: 'antialiased',
                        },
                    }
                });

                this.card.mount('#card-element');
            },

            loadPaymentMethods() {
                this.cards_loading = true;
                this.paymentMethodsLoadStatus = 1;
                axios.get('/user/payment-methods')
                    .then(function (response) {
                        console.log('payment methods', response.data)
                        this.paymentMethods = response.data;
                        this.paymentMethodsLoadStatus = 2;
                        this.cards_loading = false;
                    }.bind(this));
            },

            /***************************
             * PAYPAL
             * @param total
             * ***************************
             */

            initPaypal(total) {

                console.log('test', total)
                Vue.loadScript("https://www.paypal.com/sdk/js?client-id=AWNsde4K1V_utHBgIRqh0mSLnnEp0DH6vGjqJOv60H5qE8DVNVtaXOXAU5NbEpVgh2GRnGLpmnKw2zcP&disable-funding=credit,card&currency=GBP").then(() => {
                    var self = this;
                    paypal.Buttons({
                        onClick: function (data, actions) {
                            console.log('pp clicked')
                            if (self.table_no && self.customer_name && self.email_address) {
                                console.log('pp resolve')

                                return actions.resolve();
                            } else {
                                console.log('pp error')

                                self.alertError = true;
                                self.stripeErrorMsg = 'Please fill in all required fields';
                                return actions.reject();
                            }
                        },

                        createOrder: function (data, actions) {
                            // This function sets up the details of the transaction, including the amount and line item details.
                            return actions.order.create({
                                purchase_units: [{
                                    amount: {
                                        value: total
                                    }
                                }]
                            });
                        },

                        onApprove: function (data, actions) {
                            let paypalData = {
                                table_no: self.table_no,
                                customer_name: self.customer_name,
                                email_address: self.email_address,
                                productData: self.getProductsInCart,
                                sub_total: self.formatMoney(self.sub_total),
                                service_charge: self.formatMoney(self.service_charge),
                                total: self.formatMoney(self.total),
                            }
                            this.createOrder(paypalData);
                        }

                    }).render('#paypal-button-container');
                })
            },


            getOrderDetails() {
                axios.get('/order/' + this.order_no).then(response => {
                    this.orderDetails = response.data
                    console.log(this.orderDetails);
                })
            },

            formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
                try {
                    decimalCount = Math.abs(decimalCount);
                    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                    const negativeSign = amount < 0 ? "-" : "";

                    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                    let j = (i.length > 3) ? i.length % 3 : 0;

                    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
                } catch (e) {
                    console.log(e)
                }
            },

            payByCard() {
                let self = this;
                this.loading = true;
                let orderData = {
                    table_no: this.table_no,
                    customer_name: this.customer_name,
                    email_address: this.email_address,
                    payment: this.paymentMethodSelected,
                    productData: this.orderDetails,
                    sub_total: self.formatMoney(self.sub_total),
                    service_charge: self.formatMoney(self.service_charge),
                    total: self.formatMoney(self.total),
                }
                axios.post('/checkout/guest/charge', orderData).then(response => {
                    this.createReOrder(orderData);
                    this.loading = false;

                }).catch(error => {
                    console.log('has error')
                    this.loading = false;
                    this.alertError = true;
                    if (error.response.status == 500) {
                        this.stripeErrorMsg = error.response.data.message;
                    } else {
                        this.stripeErrorMsg = error.response.data.message;
                        this.errors = error.response.data.errors;
                        let paymentIntent = error.response.data.payment_intent;
                        self.stripe.confirmCardPayment(paymentIntent.client_secret).then(function (result) {
                            if (result.paymentIntent.status === 'succeeded') {
                                self.createOrder(orderData)
                            }
                        });
                    }
                })
            },

            createReOrder(orderData) {
                console.log('creating order...')
                axios.post('/checkout/order/re-order', orderData).then(response => {
                    this.$toasted.show(response.data.message);
                    this.$router.push({path: `/checkout/order/${response.data.order_no}`})
                })
            },

            getProfileData() {
                axios.get('/settings/profile').then(response => {
                    let userData = response.data;
                    this.customer_name = userData.name;
                    this.email_address = userData.email;
                })
            },

            getSettings() {
                this.init_loading = true;
                axios.get('/settings/system').then(response => {
                    this.numberOfTables = response.data.no_tables;
                    this.service_charge = response.data.service_charge;
                    this.init_loading = false;
                    this.createSubTotal(this.service_charge);
                })
            },
        }
    }
</script>

<style scoped>

</style>